import LoginComponent from "../components/LoginComponent";

export default function Login() {
    return (
      <>
        <LoginComponent />
      </>
    );
}